import { FeatureFlagName, getFlagValue } from '@/infra/feature-flag'
import {
  makeSkillWebAuthorizeRedirectUrl,
  makeSkillWebLogoutRedirectUrl
} from '@/main/factories/http'
import PathConstants from '@/main/routes/paths'

/**
 * Redirects to the appropriate login page based on the INTERNAL_AUTHENTICATION feature flag.
 *
 * @param returnUrl - Optional URL to return to after login
 */
export const redirectToLogin = (returnUrl?: string): void => {
  const isInternalAuthEnabled = getFlagValue(FeatureFlagName.INTERNAL_AUTHENTICATION)

  if (isInternalAuthEnabled) {
    // Always use a clean login URL without error parameters when logging out
    // If returnUrl is provided, preserve it; otherwise use the default redirect
    const loginUrl = returnUrl
      ? `${PathConstants.Routes.LOGIN.value}?redirect_uri=${encodeURIComponent(returnUrl)}`
      : PathConstants.Routes.LOGIN.value

    // Use replace to avoid adding to browser history
    window.location.replace(loginUrl)
  } else {
    window.location.href = returnUrl
      ? makeSkillWebAuthorizeRedirectUrl(returnUrl)
      : makeSkillWebLogoutRedirectUrl()
  }
}

/**
 * Clears all authentication-related data and cookies from the client.
 * Note: HttpOnly cookies can only be cleared by the server.
 */
export const clearAuthData = (): void => {
  const cookies = document.cookie.split(';')
  const hostname = window.location.hostname
  const expiration = 'expires=Thu, 01 Jan 1970 00:00:00 UTC'

  cookies.forEach(cookie => {
    const cookieName = cookie.split('=')[0].trim()

    // Clear for current path and domain
    document.cookie = `${cookieName}=; ${expiration}; path=/;`
    document.cookie = `${cookieName}=; ${expiration}; path=/; domain=${hostname};`

    // Clear for parent domain if applicable

    const domainParts = hostname.split('.')

    if (domainParts.length > 2) {
      const parentDomain = domainParts.slice(-2).join('.')
      document.cookie = `${cookieName}=; ${expiration}; path=/; domain=.${parentDomain};`
    }
  })

  sessionStorage.clear()
}
